// The ikzoekbaas.nl glyphs: the heart on step 1, the piggy bank on the rates step, the handset on the
// contact step, the accordion chevron, the birthday cake, the two slider arrows and the four share
// marks. Taken from that site itself so the page reads as it does there rather than "almost".
//
// De taart en de deel-iconen kwamen hier terecht nadat de opdrachtgever ze aanwees: er stond een
// emoji-taartje (🎂) en er stonden vier letters (f 𝕏 ✉ ☏) waar zij tekeningen hebben. Een emoji is
// geen icoon — hij rendert per systeem anders, negeert `currentColor` en valt uit de toon zodra de
// rest wél getekend is.
//
// They live apart from the site component because they are pure shape: long path data that says
// nothing about how the page works and would drown the component that does.

const HART =
  "M6.8 3.8C4.7 3.8 3 5.4 3 7.5c0 2.3 1.3 4.7 3.4 7.1 1.7 2 3.8 3.8 5.6 5.3 1.8-1.5 3.9-3.3 5.6-5.3 2-2.4 3.4-4.8 3.4-7.1 0-2-1.7-3.7-3.8-3.7s-3.8 1.7-3.8 3.7c0 .4-.2.8-.4 1.1-.2.2-.6.4-1 .4s-.8-.2-1.1-.4c-.3-.3-.4-.7-.4-1.1 0-2.1-1.7-3.7-3.7-3.7zm5.2-.6c-.6-.8-1.4-1.4-2.3-1.8C8.7 1 7.8.7 6.8.8 3 .8 0 3.7 0 7.5c0 3.4 1.9 6.5 4.1 9.1 2.2 2.6 4.9 4.8 7 6.4.3.2.6.3.9.3.3 0 .7-.1.9-.3 2-1.6 4.8-3.8 7-6.4C22.1 14 24 10.8 24 7.5c0-3.7-3-6.7-6.8-6.7-2.1 0-4 .9-5.2 2.4z";

const SPAARVARKEN =
  "M12.8 5.4c4.1-.1 7.7 3 8.2 7.1h.5c.1 0 .2 0 .3-.1l.2-.2v-.3c0-.1-.1-.2-.1-.3l-.1-.1c-.2-.2-.3-.4-.3-.7 0-.3.1-.5.3-.7s.4-.3.7-.3c.3 0 .5.1.7.3l.1.1c1.6 1.6.5 4.3-1.7 4.3H21c-.2 1.4-1 2.5-1.9 3.4v3.6c0 .3-.1.5-.3.7-.2.2-.4.3-.7.3h-3c-.2 0-.4-.1-.6-.2-.2-.1-.3-.3-.4-.5l-.4-1.1c-.1-.4-.3-.7-.6-.9-.3-.2-.7-.3-1-.3-.4 0-.7.1-1 .3-.3.2-.5.5-.6.9l-.5 1.1c-.1.2-.2.4-.4.5-.2.1-.4.2-.6.2H6c-.3 0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7v-3c0-.5-.4-1.2-1.3-1.9-.8-.6-1.9-1.1-2.8-1.1-.2 0-.5-.1-.6-.3-.2-.2-.3-.5-.3-.7v-4c0-.2.1-.4.1-.5.1-.2.2-.3.4-.4l1.6-.8C2.8 7 4.5 5.9 6 5.6V2.5c0-.2.1-.5.2-.6.1-.2.4-.3.6-.3H8c2 .2 4.1 1.9 4.8 3.8zM8 6.5V3.6c1.2.3 2.9 1.5 3 2.9 0 .1 0 .3.1.4.1.1.1.2.2.3.1.1.2.2.4.2.1 0 .3.1.4 0h.3c3.5-.4 6.6 2.5 6.6 6 0 1-.4 2-1.1 2.7l-.2.2c-.3.4-.7.7-.7 1.2v3h-1.3l-.1-.4c-.3-.8-.7-1.4-1.4-1.9-.6-.5-1.4-.7-2.2-.7-.8 0-1.6.2-2.2.7-.6.5-1.1 1.1-1.4 1.9l-.1.4H7v-2C7 17 6 15.8 4.9 15c-.9-.6-1.8-1.1-2.9-1.3v-2.5l1.4-.7.3-.3c.2-.2.2-.3.3-.5.4-1.4 1.9-2.2 3-2.2.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7zm-.5 6c.4 0 .8-.2 1.1-.4.2-.3.4-.7.4-1.1 0-.4-.2-.8-.4-1.1-.3-.3-.7-.4-1.1-.4-.4 0-.8.2-1.1.4-.2.3-.4.7-.4 1.1 0 .4.2.8.4 1.1.3.2.7.4 1.1.4z";

const TELEFOON =
  "M8.2 15.8c2.9 2.9 5.6 4.5 7.5 5.4 1.7.8 3.8.2 5.4-1.4l.4-.4-4.4-2.8c-.8 1.2-2.4 1.9-4 1.3-1.2-.5-2.8-1.4-4.2-2.8-1.4-1.4-2.3-3-2.8-4.2-.7-1.6 0-3.2 1.3-4L4.6 2.5l-.3.4C2.7 4.5 2.1 6.5 2.8 8.2c.9 2 2.5 4.7 5.4 7.6zm6.5 7.6c-2.3-1-5.2-2.8-8.3-5.9-3.1-3.1-4.9-6-5.9-8.3C-.8 6.2.4 3.1 2.4 1l.4-.4c.3-.3.6-.5.9-.6h1.2c.4 0 .7.2 1 .4.3.2.6.5.8.8l3.5 5.5c.1.1.2.3.2.5v.5c0 .2-.1.3-.2.5-.2.1-.3.2-.5.3l-.7.4c-.6.2-.7.7-.6 1 .4 1 1.1 2.3 2.2 3.4s2.4 1.8 3.4 2.2c.3.1.8 0 1.1-.5l.4-.8c.1-.2.2-.3.3-.4.1-.1.3-.2.5-.2s.3-.1.5 0c.2 0 .3.1.5.2l5.5 3.5c.3.2.6.5.8.8.2.3.3.7.4 1 0 .4 0 .7-.1 1.1-.1.4-.3.7-.6.9l-.4.4c-2.1 2.1-5.2 3.3-8.2 1.9z";

const CHEVRON =
  "M.4 5.7c.3-.3.7-.4 1.1-.4.4 0 .8.2 1.1.4l9.4 9.4 9.4-9.4c.1-.1.3-.3.5-.3s.4-.1.6-.1c.2 0 .4 0 .6.1.2.1.4.2.5.3.1.1.3.3.3.5.1.2.1.4.1.6 0 .2 0 .4-.1.6-.1.2-.2.3-.3.5L13.1 18.3c-.3.3-.7.4-1.1.4-.4 0-.8-.2-1.1-.4L.4 7.8c-.2-.3-.4-.6-.4-1s.2-.8.4-1.1z";

/** Het taartje bij de geboortedatum. */
const TAART =
  "M14.868 3.125C14.868 4.16 13.96 5 12.845 5c-1.118 0-2.024-.84-2.024-1.875C10.822 2.089 12.846 0 12.846 0s2.023 2.09 2.023 3.125zM1.17 13.64l1.882 1.19 1.724 7.393a1.004 1.004 0 0 0 .986.775h14.163c.229 0 .45-.077.63-.218a.999.999 0 0 0 .355-.557l1.726-7.393 1.88-1.19a1.006 1.006 0 0 0 .46-.629.987.987 0 0 0-.133-.764 1.005 1.005 0 0 0-.647-.44 1.024 1.024 0 0 0-.77.15l-.541.341c-.34-2.376-2.404-4.3-5.012-4.3h-4.018V7a.994.994 0 0 0-.296-.706 1.018 1.018 0 0 0-1.43 0 .994.994 0 0 0-.297.707v1H7.815a5.044 5.044 0 0 0-5.011 4.3l-.542-.343a1.021 1.021 0 0 0-1.397.303.99.99 0 0 0 .306 1.381zM6.569 21l-1.155-4.95a5.115 5.115 0 0 0 4.123-.667l1.625-1.072a3.06 3.06 0 0 1 3.367 0l1.626 1.072a5.094 5.094 0 0 0 4.123.667L19.12 21H6.568zm11.306-11a3.057 3.057 0 0 1 2.347 1.099 2.966 2.966 0 0 1 .629 2.49l-.254.16a3.06 3.06 0 0 1-3.32-.03l-1.626-1.072a5.1 5.1 0 0 0-5.611 0L8.414 13.72a3.06 3.06 0 0 1-3.318.03l-.256-.16a2.966 2.966 0 0 1 .628-2.491 3.03 3.03 0 0 1 1.049-.81c.406-.19.85-.288 1.298-.288h10.06zM9.81 18a.994.994 0 0 0-.296-.707 1.017 1.017 0 0 0-1.43 0 .994.994 0 0 0-.297.707v1c0 .265.106.52.296.707a1.018 1.018 0 0 0 1.43 0A.994.994 0 0 0 9.81 19v-1zm4.046 0a.994.994 0 0 0-.296-.707 1.017 1.017 0 0 0-1.43 0 .994.994 0 0 0-.297.707v1c0 .265.107.52.296.707a1.018 1.018 0 0 0 1.431 0 .994.994 0 0 0 .296-.707v-1zm4.047 0a.994.994 0 0 0-.297-.707 1.017 1.017 0 0 0-1.43 0 .994.994 0 0 0-.296.707v1c0 .265.106.52.296.707a1.018 1.018 0 0 0 1.43 0 .994.994 0 0 0 .297-.707v-1z";

/** De twee pijlen onder de fotoslider en in de paginering — met een lange staart, zoals daar. */
const PIJL_LINKS =
  "M11.6 1.7c.3.3.4.6.4 1s-.1.7-.4.9l-7.1 7.1h18.1c.4 0 .7.1.9.4.3.3.4.6.4.9 0 .4-.1.7-.4.9-.3.3-.6.4-.9.4h-18l7.1 7.1c.2.3.4.6.4.9 0 .3-.1.7-.4.9-.2.2-.6.4-.9.4s-.7-.1-.9-.4L.4 13c-.3-.3-.4-.6-.4-1s.1-.7.4-.9l9.3-9.3c.3-.2.6-.4.9-.4.4-.1.8.1 1 .3z";

const PIJL_RECHTS =
  "M12.4 1.7c.3-.3.5-.4.9-.4s.7.1.9.4l9.3 9.3c.3.3.4.5.4.9s-.1.7-.4.9l-9.3 9.3c-.3.3-.5.4-.9.4s-.7-.1-.9-.4c-.3-.1-.4-.4-.4-.8s.1-.7.4-.9l7.1-7.1H1.3c-.4 0-.7-.1-.9-.4-.3-.2-.4-.5-.4-.9s.1-.7.4-.9.5-.4.9-.4h18.1l-7.1-7.1c-.2-.3-.3-.5-.3-.9s.1-.7.4-1z";

/** De vier deelmerken, in de volgorde waarin zij ze zetten. */
const DEEL_PADEN: Record<string, string> = {
  facebook:
    "M13.9 24V13.1h3.7l.6-4.3H14V6.1c-.1-1.3.2-2.1 2-2.1h2.3V.2c-.5-.1-1.8-.2-3.4-.2-3.3 0-5.5 2-5.5 5.6v3.1H5.8V13h3.7v11h4.4z",
  x:
    "M14.2 10.2 23 0h-2.1l-7.6 8.8-6-8.8h-7l9.2 13.3L.3 24h2.1l8-9.3 6.4 9.3h7l-9.6-13.8zm-2.8 3.3-.9-1.3L3.1 1.6h3.2l6 8.5.9 1.3L21 22.5h-3.2l-6.4-9z",
  mail:
    "M.7 3.8c.3-.4.7-.8 1.1-1 .5-.2 1-.4 1.5-.4h17.3c1.1 0 2.1.6 2.7 1.4.4.6.7 1.3.7 2v12.3c0 1.9-1.5 3.4-3.4 3.4H3.4C1.5 21.6 0 20 0 18.2V5.8c0-.7.2-1.4.7-2zm2.8 1l7.6 8.4c.1.1.2.2.4.3.2.1.3.1.5.1s.3 0 .5-.1.3-.2.4-.3l7.6-8.4h-17zm18.1 2.3l-6.9 7.6c-.3.4-.7.7-1.2.9-.5.2-1 .4-1.5.4s-1-.1-1.5-.3c-.5-.2-.9-.5-1.2-.9L2.4 7.1v11c0 .6.5 1 1 1h17.3c.5 0 1-.4 1-1v-11z",
  whatsapp:
    "M2.8 12c0-1.9.6-3.7 1.6-5.3 1-1.6 2.5-2.8 4.3-3.5 1.7-.7 3.6-.9 5.5-.5C16 3.1 17.7 4 19 5.3c1.3 1.3 2.2 3 2.6 4.9.4 1.8.2 3.7-.5 5.5-.7 1.7-1.9 3.2-3.5 4.3-1.6 1-3.4 1.6-5.3 1.6-1.8 0-3.6-.5-5.1-1.5-.1-.1-.3-.1-.4-.2h-.5l-3.2 1L4.3 18c.1-.2.1-.3.1-.5s-.1-.4-.2-.5c-.9-1.5-1.4-3.2-1.4-5zM12.3.3C5.8.3.6 5.5.6 12c0 2.1.5 4 1.5 5.7L.2 22.2c-.2.2-.2.4-.2.6 0 .2.1.4.3.6.1.2.3.3.5.3.2.1.4.1.6 0l5-1.5c1.8 1 3.8 1.5 5.8 1.5C18.8 23.7 24 18.5 24 12 24 5.5 18.8.3 12.3.3zm2.5 14.1l-1.5 1c-.8-.5-1.6-1-2.2-1.7-.7-.7-1.3-1.5-1.8-2.4l.9-.8c.2-.2.3-.4.4-.6 0-.3 0-.5-.1-.7L9.4 7c-.1-.1-.2-.3-.4-.4-.1-.1-.3-.1-.4-.2h-.5c-.2 0-.3.1-.4.2l-.4.4c-.8.7-1.3 2-.9 3.2.7 1.9 1.8 3.7 3.2 5.2 2 2 4.1 2.8 5.3 3.1 1 .2 1.9-.1 2.5-.6l.7-.5c.1-.1.2-.3.3-.4.1-.2.1-.3.1-.5s-.1-.4-.2-.5c-.1-.2-.2-.3-.4-.4L16 14.5c-.2-.1-.4-.2-.6-.2-.2-.1-.4 0-.6.1z",
};

const PADEN: Record<number, string> = { 1: HART, 2: SPAARVARKEN, 3: TELEFOON };

/** Het taartje voor de geboortedatum. */
export function TaartIcoon() {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
      <path fill="currentColor" d={TAART} />
    </svg>
  );
}

/** De pijl onder de fotoslider en in de paginering. */
export function SliderPijl({ richting }: { richting: "links" | "rechts" }) {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
      <path fill="currentColor" d={richting === "links" ? PIJL_LINKS : PIJL_RECHTS} />
    </svg>
  );
}

/** Eén deelmerk. De naam is de sleutel in {@link DEEL_PADEN}. */
export function DeelIcoon({ merk }: { merk: keyof typeof DEEL_PADEN }) {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
      <path fill="currentColor" d={DEEL_PADEN[merk]} />
    </svg>
  );
}

/** The glyph for step 1, 2 or 3. */
export function StapIcoon({ nr }: { nr: number }) {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true" className="izb__stap-icoon">
      {/* The piggy bank is an outline: without evenodd its inside fills in and you get a blob. */}
      <path fill="currentColor" fillRule={nr === 2 ? "evenodd" : undefined} d={PADEN[nr] ?? HART} />
    </svg>
  );
}

/** The accordion chevron; open turns it half a turn, as it does there. */
export function StapChevron({ open }: { open: boolean }) {
  return (
    <svg
      viewBox="0 0 24 24"
      role="img"
      aria-hidden="true"
      className={open ? "izb__chevron is-open" : "izb__chevron"}
    >
      <path fill="currentColor" d={CHEVRON} />
    </svg>
  );
}

/** The envelope in the contact button; it sits left of the label there. */
export function KnopEnvelop() {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true" className="izb__knop-pijl">
      <path
        fill="currentColor"
        d="M2 4h20c.6 0 1 .4 1 1v14c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1zm1 3.2V18h18V7.2l-8.4 6c-.4.3-.8.3-1.2 0L3 7.2zM20 6H4l8 5.7L20 6z"
      />
    </svg>
  );
}

/** The arrow in the lime buttons. */
export function KnopPijl() {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true" className="izb__knop-pijl">
      <path
        fill="currentColor"
        d="M13.3 4.3c.4-.4 1-.4 1.4 0l6.5 6.5c.4.4.4 1 0 1.4l-6.5 6.5c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l4.8-4.8H3c-.6 0-1-.4-1-1s.4-1 1-1h15.1l-4.8-4.8c-.4-.4-.4-1 0-1.4z"
      />
    </svg>
  );
}
